import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { hasPrivilege } from "../api/token";
import TrackerList from '../components/TrackerList';


export default function Tracker() {
const navigate = useNavigate();
const administration_view = hasPrivilege('tracker_view');

  useEffect(() => {
    if (!administration_view) {
      navigate("/");
    }
  }, [navigate, administration_view])

  return (
    <div>
      <TrackerList />
    </div>
  )
}
